export default __webpack_public_path__ + "static/media/dropverse_showcase_1.webp";